import React from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import CopyrightFooter from "../Components/CopyrightFooter";
import Header from "../Components/Headers";
import OrderDetails from "../Components/OrderDetails";
import KitchenReport from "./Pages/KitchenReport";

function Kitchen() {
  const { url } = useRouteMatch();
  return (
    <React.Fragment>
      <Header Layout="Kitchen" />
      <main className="pt-60">
        <Switch>
          <Route path={url} exact>
            <OrderDetails display="kitchen" />
          </Route>
          <Route path={url + `/Report/`} exact component={KitchenReport} />
        </Switch>
      </main>
      <CopyrightFooter />
    </React.Fragment>
  );
}
export default React.memo(Kitchen);
